import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'mwp-dialog-translation',
    templateUrl: './translation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogTranslationComponent {

    constructor(
        private dialogRef: MatDialogRef<DialogTranslationComponent>,
    ) {
    }

    close(): void {
        this.dialogRef.close();
    }
}